export default {
    name: 'Segments',
    data: () => ({
        segments: [
            {
                name: 'Condomínio',
                class: 'fas fa-building'
            },
            {
                name: 'Hotel',
                class: 'fas fa-concierge-bell'
            },
            {
                name: 'Escola',
                class: 'fas fa-graduation-cap'
            },
            {
                name: 'Corporativo',
                class: 'fas fa-briefcase'
            },
            {
                name: 'Shopping',
                class: 'fas fa-shopping-cart'
            },
            {
                name: 'Construção civil',
                class: 'fas fa-hard-hat'
            }
        ]
    })
};
